import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import {
  ScheduledJobsResponse,
  SectionUpdatePayload,
} from './types/section-schedules'

class SectionSchedulesApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getSectionSchedules = (entity_id: string) =>
    this.api.get<ScheduledJobsResponse>(
      `/gw2/puja/internal/v1/schedules/entity/${entity_id}?action=section_update`,
    )

  createSectionSchedule = (payload: SectionUpdatePayload) =>
    this.api.post(`/gw2/puja/internal/v1/schedules`, payload)

  updateSectionSchedule = (
    scheduled_id: string,
    payload: Pick<SectionUpdatePayload, 'name' | 'data'>,
  ) =>
    this.api.put(
      `/gw2/puja/internal/v1/schedules/${scheduled_id}
`,
      payload,
    )

  deleteSectionSchedule = (scheduled_id: string) =>
    this.api.delete(`/gw2/puja/internal/v1/schedules/${scheduled_id}`)
}

export default SectionSchedulesApi
